export default __webpack_public_path__ + "static/media/mini_ic_remove.76a6393a.svg";